var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FloatingArrow, FloatingPortal, flip, offset, arrow, shift, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole, useTransitionStyles, autoUpdate, } from "@floating-ui/react";
import React, { useCallback, useRef, useState } from "react";
import classNames from "classnames";
const ARROW_HEIGHT = 8;
const GAP = 2;
export function QuiTooltip(_a) {
    var { children, disabled, content, placement, padding = "sm lg", className, delay, onOpen, onClose } = _a, otherProps = __rest(_a, ["children", "disabled", "content", "placement", "padding", "className", "delay", "onOpen", "onClose"]);
    const [isOpen, setIsOpen] = useState(false);
    const arrowRef = useRef(null);
    const tooltipOpen = !disabled && isOpen;
    const offsetValue = ARROW_HEIGHT + GAP;
    const onOpenChange = useCallback((newIsOpen) => {
        setIsOpen(newIsOpen);
        if (newIsOpen) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
        else {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [onOpen, onClose]);
    const { refs, context, floatingStyles } = useFloating({
        open: tooltipOpen,
        onOpenChange,
        whileElementsMounted: autoUpdate,
        middleware: [
            flip(),
            shift(),
            offset(offsetValue),
            arrow({
                padding: GAP,
                element: arrowRef,
            }),
        ],
        placement,
    });
    const { isMounted, styles } = useTransitionStyles(context, {
        duration: 200,
    });
    const hover = useHover(context, {
        delay: {
            close: delay,
        },
    });
    const dismiss = useDismiss(context);
    const role = useRole(context, {
        role: "tooltip",
    });
    const focus = useFocus(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([hover, dismiss, role, focus]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", Object.assign({ className: "qui-d-inline-flex", ref: refs.setReference }, getReferenceProps()), children),
        React.createElement(FloatingPortal, null, isMounted && (React.createElement("div", Object.assign({ ref: refs.setFloating, style: Object.assign(Object.assign(Object.assign({}, floatingStyles), styles), otherProps.style) }, getFloatingProps({
            className: classNames(`qui-tooltip`, className, padding && `qui-padding-${padding.replace(" ", "-")}`),
        }), otherProps),
            content,
            React.createElement(FloatingArrow, { height: ARROW_HEIGHT, width: 16, tipRadius: 2, className: "qui-popover-arrow", ref: arrowRef, context: context }))))));
}
